
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import { mapState } from 'vuex'

export default {
name: 'app',
components: {
Tabbar,
TabbarItem,
Loading,
Alert
},
data () {
return {
isSelected: true,
platcode: ''
}
},
created: function () {
this.platcode = this.$UserUtils.getPlatCode()
},
methods: {
onAlertHide: function () {
let that = this
that.$store.commit('hideAlert')
console.log(that.$store.state.alertShowTag)
}
},
computed: {
...mapState([
'loadingShowTag',
'alertContent',
'alertTitle'
]),
alertShowTag: {
get: function () {
return this.$store.state.alertShowTag
},
set: function () {
console.log(this.$store.state.alertShowTag)
}
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue